<template>
    <div class="message" id="message">
        <el-dialog title="消息" :visible.sync="reply" width="800px" :modal="true" :lock-scroll="true" v-dialogDrag>
            <h3 style="color:#333333;">{{showNow.title}}</h3>
            <p style="margin-top:30px;font-size:14px;color:#333333;overflow:auto;max-height:600px;" v-html="showNow.content">{{showNow.content}}</p>
        </el-dialog>
        <h1 class="title">消息</h1>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="message-wrapper">
            <el-tab-pane label="未读消息" name="first">
                <div class="reply-message" v-for="(unread,index) in $store.state.unreadList" :key="index">
                    <span
                        style="display:inline-block;height:40px;line-height:40px;margin-left:25px;font-size:14px;cursor:pointer;"
                        @click="showUnreadReply(unread)"
                    >{{unread.title}}</span>
                    <span style="margin-right:25px;float:right;height:40px;line-height:40px;color:#999999;font-size:14px;" v-html="unread.createTime"></span>
                </div>
                <el-pagination
                    style="float:right;margin-top:40px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 15]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="$store.state.unreadMessage"
                ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="已读消息" name="second">
                <div class="reply-message" v-for="(read,index) in $store.state.readList" :key="index">
                    <span
                        style="display:inline-block;height:40px;line-height:40px;margin-left:25px;font-size:14px;cursor:pointer;"
                        @click="showReply(read)"
                    >{{read.title}}</span>
                    <span style="margin-right:25px;float:right;height:40px;line-height:40px;color:#999999;font-size:14px;">{{read.createTime}}</span>
                </div>
                <el-pagination
                    style="float:right;margin-top:40px;"
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="currentPage2"
                    :page-sizes="[10, 15]"
                    :page-size="pageSize2"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="$store.state.readTotal"
                ></el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    data () {
        return {
            activeName: "first",
            remain: 0,
            reply: false,
            unreadList: [],
            readList: [],
            showNow: {},
            currentPage2: 1,
            currentPage: 1,
            pageSize: 10,
            pageSize2: 10,
            // total: 100,
        }
    },
    created () {
    },
    methods: {
        getMessageMinHeight(val) {
            if(val > 10 && val <= 15) {
                document.getElementById('message').style.minHeight = '1200px'
            }else if(val == 10) {
                document.getElementById('message').style.minHeight = '900px'
            }
        },
        handleSizeChange (val) {
            this.pageSize = val
            this.getUnreadMessage()
            this.getMessageMinHeight(val)
        },
        handleCurrentChange (val) {
            this.currentPage = val
            this.getUnreadMessage()
        },
        handleSizeChange2 (val) {
            this.pageSize2 = val
            this.getReadMessage()
            this.getMessageMinHeight(val)
        },
        handleCurrentChange2 (val) {
            this.currentPage2 = val
            this.getReadMessage()
        },
        getUnreadMessage () {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/userMessageList',
                    this.postData({
                        userId: sessionStorage.userUuid,
                        state: 1,
                        pageNumber: this.currentPage,
                        pageSize: this.pageSize
                    })
                )
                .then(res => {
                    if (res.code === '200') {
                        this.$store.commit('unreadList', res.data.list)
                        this.$store.commit('unreadMessage', res.data.totalCount)
                        this.total = this.$store.state.unreadMessage
                    }
                })
        },
        getReadMessage () {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/userMessageList',
                    this.postData({
                        userId: sessionStorage.userUuid,
                        state: 0,
                        pageNumber: this.currentPage2,
                        pageSize: this.pageSize2
                    })
                )
                .then(res => {
                    if (res.code === '200') {
                        this.$store.commit('readList', res.data.list)
                        this.$store.commit('readTotal', res.data.totalCount)
                        this.total2 = this.$store.state.readTotal
                    }
                })
        },
        handleClick (tab, event) {
            console.log(tab, event)
        },
        showReply (read) {
            this.showNow = read
            this.reply = true
        },
        showUnreadReply (unread) {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/updateUserMessage',
                    this.postData({
                        id: unread.id,
                        state: 0
                    })
                )
                .then(res => {
                    if (res.code === '200') {
                        this.showNow = unread
                        this.getUnreadMessage()
                        this.getReadMessage()
                        this.reply = true
                    }
                })
        },
        descInput () {
            var txtVal = this.suggestion_form.content.length
            this.remain = txtVal
        }
    }
};
</script>
<style lang="scss">
.message {
    width: 1100px;
    border-left: 1px #dcdcdc solid;
    border-right: 1px #dcdcdc solid;
    background: rgb(255, 255, 255);
    min-height: 900px;
    .el-dialog {
        h3 {
            margin: 0;
            padding-bottom: 15px;
            border-bottom: 1px #e5e5e5 solid;
        }
    }
    .el-dialog__header {
        background-color: #f3f3f3;
        border: 1px #d2d2d2 solid;
    }
    .el-dialog__title {
        color: #333333 !important;
        font-size: 16px;
    }
    .el-dialog__body {
        margin-right: 30px;
        padding: 30px 0 15px 20px;
    }
    .el-dialog__close {
        margin-top: 8px;
        font-size: 24px;
    }

    .title {
        font-weight: normal;
        font-size: 24px;
        margin: 25px 40px;
        color: #333333;
    }
    .el-tabs__item {
        width: 120px;
        padding: 0;
        text-align: center;
        border: none;
        font-size: 16px;
    }
    .el-tabs {
        margin: 0 40px;
    }
    #tab-first {
        margin-left: 25px;
    }
    .el-tabs__item.is-active {
        background-color: #1060ab;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        color: #fff;
    }
    .el-tabs__active-bar {
        display: none;
    }
    .el-tabs__header {
        box-shadow: 0 10px #e5f1fb;
        margin-bottom: 10px;
    }
    .el-tabs__nav-wrap::after {
        background-color: #1060ab;
    }
    .message-wrapper {
        .reply-message {
            padding: 10px 0;
            border-bottom: 1px #e5e5e5 solid;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/message.vue